import React from "react";
import { SubscriptionPlanLoaderTemplate } from "themes/application/payment/components";

function SubscriptionPlanLoader(props) {
    return <SubscriptionPlanLoaderTemplate {...props} />;
}

export default SubscriptionPlanLoader;
